

export default {
  enums: [
    { id: 'CONSUMER' },
    { id: 'GROUP' },
    { id: 'TRANSPORTATION' },
  ]
};